import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

interface StyledBoxProps {
  isLoading: boolean;
}

const StyledBox = styled(Box)(({ isLoading }: StyledBoxProps) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: isLoading ? '100%' : '80%',
  backgroundColor: '#FFF',
  textAlign: 'center',
}));

export default StyledBox;
